// @flow
import i18n from "i18next";
import k from "src/i18n/keys";

import React from "react";
import { connect } from "react-redux";

import { UnhideOption } from "./styles";
import { unhideMessage } from "src/actions/chatmenu";

import type { UID, RoomId } from "src/types";

import GenericNotification from "./Notification/Generic";

type Props = {
  message: any,
  roomId: RoomId,
  currentUser: UID,
  unhide: Function,
};

const Hidden = ({ message, roomId, currentUser, unhide }: Props) => {
  const { id, hiddenBy } = message;
  return (
    <GenericNotification
      message={message}
      isCurrentUser={currentUser === hiddenBy}
      hideTimestamp
    >
      <i>{i18n.t(k.HID_A_MESSAGE)}</i>
      <UnhideOption onClick={() => unhide(roomId, id)}>
        {i18n.t(k.UNHIDE)}
      </UnhideOption>
    </GenericNotification>
  );
};

const mapStateToProps = ({ app }) => ({
  currentUser: app.currentUser.uid,
  roomId: app.chatRooms.current,
});

export default connect(mapStateToProps, {
  unhide: unhideMessage,
})(Hidden);
